
import classnames from 'classnames'
import React from 'react'
import { Container } from 'react-bootstrap'
import seven_content1 from '../../resources/images/seven_content1.png'
import seven_content2 from '../../resources/images/seven_content2.png'
import seven_content3 from '../../resources/images/seven_content3.png'
import seven_lc1 from '../../resources/images/seven_lc1.png'
import seven_lc2 from '../../resources/images/seven_lc2.png'
import seven_lc3 from '../../resources/images/seven_lc3.png'
import eight_img_pay from '../../resources/images/eight_img_pay.png'
import seven_title_icon from '../../resources/images/seven_title_icon.png'
import nine_bg from '../../resources/images/nine_bg.png'
import lifeLeft from '../../resources/images/life-left.png'
import lifeRight from '../../resources/images/life-right.png'
import enIcon from '../../resources/images/en-icon.png'
import mxBanner from '../../resources/images/mxBanner.png'
import advantage1 from '../../resources/images/advantage1.png'
import advantage2 from '../../resources/images/advantage2.png'
import advantage3 from '../../resources/images/advantage3.png'
import advantage4 from '../../resources/images/advantage4.png'

import './body.css'
import { useTranslation, getI18n } from 'react-i18next'
import { useContext } from 'react'
import StoreContext from '../store';
const BodyContext = () => {
    const { t } = useTranslation()
    const { language } = getI18n()
    const isTHLanguage = language == 'th'
    const isMXLanguage = language == 'mx'
    const store: any = useContext(StoreContext)
    return <>
        <Container fluid={true} className='p-t-58 px-0' id='home'>
            <div className='maxboxxnine' id='home'>
                <div className='maxbox_nine' >
                    <div className='box_nine' >
                        <div className='nine_txt'>
                            {t('全球领先的贷款服务')}
                        </div>
                        <div className='seven_content_txt'>{t('最高可借')}{t('80000')}{t('฿')}</div>
                        <div className='bt_ljty_nine'>{t('立即申请')}</div>
                    </div>
                    <div className='banner_box_nine'>
                        <img className='banner_nine' src={nine_bg} />
                    </div>
                </div>
            </div>
            <div className='nine_box_color'>
                <div className='conten_box_nine'>
                    <div className='title_box_nine'>
                        <div className='title_txt'>{t('我们的优势')}</div>
                    </div>

                    <div className='conten_txt_box'>
                        <div className='neirong_box_nine'>
                            <div className='neirong_list_nine'>

                                <div className='neirong_left_egigt' style={{ display: "flex", alignItems: "center" }}>
                                    <div className='top_txt_egigt'>{t('易申请')}</div>
                                    <div className='bottom_txt_egigt'>{t('3步走完流程')}</div>
                                </div>

                            </div>
                            <div className='neirong_list_nine'>
                                <div className='neirong_left_egigt'>
                                    <div className='top_txt_egigt'>{t('秒审批')}</div>
                                    <div className='bottom_txt_egigt'>{t('30秒审批')}</div>
                                </div>
                            </div>
                            <div className='neirong_list_nine'>

                                <div className='neirong_left_egigt' style={{ display: "flex", alignItems: "center" }}>
                                    <div className='top_txt_egigt'>{t('高额度')}</div>
                                    <div className='bottom_txt_egigt'>{t('最高可借')}80000</div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
            </div>
            <div className='mt-82 d-flex justify-content-center flex-column align-items-center '>
                <span className="mx-center-Warp-title">
                    {t('我们的优势')}
                </span>
                <hr style={{ width: '83px', height: '3px', color: '#4051A1', opacity: 1, marginTop: 30 }}></hr>
                <div className="d-flex mt-82 mb-82 justify-content-around advantage-warp ">
                    <div className='advantage-item  d-flex flex-column align-items-center ' >
                        <img src={advantage1}></img>
                        <hr />
                        <p className='advantage-item-title'>{t('额度高')}</p>
                        <p className='advantage-item-title-d'>{t('最高可借额度')}20000</p>
                    </div>
                    <div className='advantage-item  d-flex flex-column align-items-center ' >
                        <img src={advantage2}></img>
                        <hr />
                        <p className='advantage-item-title'>{t('速度快')}</p>
                        <p className='advantage-item-title-d'>{t('30秒审批，3分钟到账')}</p>
                    </div>
                    <div className='advantage-item  d-flex flex-column align-items-center ' >
                        <img src={advantage3}></img>
                        <hr />
                        <p className='advantage-item-title'>{t('操作简单')}</p>
                        <p className='advantage-item-title-d'>{t('手机即可申请，还款灵活操作')}</p>
                    </div>
                    <div className='advantage-item  d-flex flex-column align-items-center ' >
                        <img src={advantage4}></img>
                        <hr />
                        <p className='advantage-item-title'>{t('低利息')}</p>
                        <p className='advantage-item-title-d'>{t('0抵押0担保额度有保障')}</p>

                    </div>
                </div>
            </div>
            <div className='nine_lc_box_bg'>

                <div id='question' className="d-flex flex-column align-items-center w-100">
                    <div className="d-flex pb-warp justify-content-center align-items-center " >
                        <div style={{ backgroundImage: `url(${lifeLeft})` }} className="en-life-s"> </div>
                        <label style={{ padding: '0px 20px' }} >{t('常见问题')}</label>
                        <div style={{ backgroundImage: `url(${lifeRight})` }} className="en-life-s"> </div>
                    </div>
                    <div className="d-flex pb-warp flex-column">
                        <div className="d-flex ">
                            <div className="d-flex flex-column align-items-end">
                                <div className="en-step-num">Part1</div>
                                <div style={{ backgroundImage: `url(${enIcon})` }} className="en-icon"></div>
                            </div>
                            <div style={{ paddingTop: '5px', marginLeft: '20px' }} >
                                <p className="en-setp-d"> {t('申请的门槛高吗？')}</p>
                                <p className="en-setp-t"> {t('提供本人身份证，本人银行卡。年龄在18岁以上的注册用户，均可申请')}</p>
                            </div>
                        </div>
                        <div className="d-flex mt-5">
                            <div className="d-flex flex-column align-items-end">
                                <div className="en-step-num">Part2</div>
                                <div style={{ backgroundImage: `url(${enIcon})` }} className="en-icon"></div>
                            </div>
                            <div style={{ paddingTop: '5px', marginLeft: '20px' }} >
                                <p className="en-setp-d"> {t('借款后可以多久到账？')}</p>
                                <p className="en-setp-t">{t('通过审核后最快三分钟到账')}</p>
                            </div>
                        </div>

                        <div className="d-flex mt-5">
                            <div className="d-flex flex-column align-items-end">
                                <div className="en-step-num">Part3</div>
                                <div style={{ backgroundImage: `url(${enIcon})` }} className="en-icon"></div>
                            </div>
                            <div style={{ paddingTop: '5px', marginLeft: '20px' }} >
                                <p className="en-setp-d"> {t('什么时候可以还款?')}</p>
                                <p className="en-setp-t"> {t('可以进行提前还款')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </Container>
    </>
}
export default BodyContext